import type { ReactNode } from "react";
import { twJoin } from "tailwind-merge";

const BRAND_MARK_SIZE_CLASSES = {
  sm: "h-icon-control",
  md: "h-icon-display",
} as const;

const BRAND_MARK_PROPORTION_CLASSES = {
  intrinsic: undefined,
  panoramic: "aspect-brand-mark-panoramic",
} as const;

export type BrandMarkProps = {
  src: string;
  alt: string;
  size?: keyof typeof BRAND_MARK_SIZE_CLASSES;
  proportion?: keyof typeof BRAND_MARK_PROPORTION_CLASSES;
};

/** Intrinsic-ratio partner or product mark with a closed, system-owned display height. */
export function BrandMark({ src, alt, size = "md", proportion = "intrinsic" }: BrandMarkProps): ReactNode {
  return (
    <img
      src={src}
      alt={alt}
      className={twJoin(BRAND_MARK_SIZE_CLASSES[size], BRAND_MARK_PROPORTION_CLASSES[proportion])}
    />
  );
}
